import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    date: String,
    time: String,
    notes: String
  }

  open(event) {
    event.preventDefault()

    const panel = document.getElementById("inbox-viewing-schedule")
    const controller = this.application.getControllerForElementAndIdentifier(panel, "inbox-viewing-panel")
    if (!controller) return

    controller.openScheduleWithPrefill({
      date: this.hasDateValue ? this.dateValue : undefined,
      time: this.hasTimeValue ? this.timeValue : undefined,
      notes: this.hasNotesValue ? this.notesValue : undefined
    })
  }
}
